export const enum AdjustmentStatuses {
  Created = 'created',
  InProgress = 'in_progress',
  Rejected = 'rejected',
  Completed = 'completed',
}
